export default __webpack_public_path__ + "static/media/unstaking-step-three-zenusdt.6fa124f3.svg";